import { createContext, useContext } from 'react'
import type { Project } from '../api/types'

export interface ProjectContextValue {
  projectId: string
  project: Project
  isAdmin: boolean
  refetch: () => void
}

export const ProjectCtx = createContext<ProjectContextValue | null>(null)

export function useProject(): ProjectContextValue {
  const v = useContext(ProjectCtx)
  if (!v) throw new Error('useProject() outside <ProjectProvider>')
  return v
}
